import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";

import { baseStyles } from "../styles";
import {PDFContext} from "../BasePDF";
import {LEASE_DEAL_DARK, PURCHASE_DEAL_LIGHT} from "../../../../contexts/DealContext";

export const PaymentInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;

    const pageColor = pdfData.lease_type === 'Finance' ? PURCHASE_DEAL_LIGHT : LEASE_DEAL_DARK

    return (
        <View style={{...baseStyles.marginRight, ...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pageColor}}>
                <Text>Payment Information</Text>
            </View>

            <View>
                <View style={baseStyles.flexBetween}>
                    <Text>Base Monthly Payment</Text>
                    <Text>{pdfData.base_payment.toDollarFormat()}</Text>
                </View>

                <View style={{...baseStyles.flexBetween, ...baseStyles.boldTopBorder}}>
                    <Text>Total Monthly Payment</Text>
                    <Text>{pdfData.monthly_payment.toDollarFormat()}</Text>
                </View>
            </View>
        </View>
    )
}